import classNames from "classnames";
import { AscButton, AscLoading } from "../../components";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import AscAuthFlowLayout from "../AscAuthFlowLayout/AscAuthFlowLayout";
import styles from "./AscVerificationView.module.scss";

export interface AscVerificationViewProps {
  className?: string;
  loading?: boolean;
  resendLoading?: boolean;
  verificationFailed?: boolean;
  onResendVerificationEmail?: () => void;
}

export default function AscVerificationView({
  className,
  loading = false,
  resendLoading = false,
  verificationFailed = false,
  onResendVerificationEmail,
}: AscVerificationViewProps) {
  return (
    <AscAuthFlowLayout alignment="right" roundSideImage>
      <div
        data-testid="asc-email-sent-view"
        className={classNames(styles.ground, className)}
      >
        <header className={styles.heading}>
          <AscLoading
            className={styles.loading}
            loading={loading}
            type="spinner"
          />
          <AscHeading className={styles.title} level={1}>
            Verifying your email
          </AscHeading>
          <AscParagraph className={styles.subTitle}>
            This will only take a few seconds...
          </AscParagraph>
        </header>

        {verificationFailed ? (
          <footer className={styles.footer}>
            <AscButton
              className={styles.footerButton}
              variant="primary"
              size="large"
              onClick={onResendVerificationEmail}
              disabled={loading || !verificationFailed}
              loading={resendLoading}
            >
              Resend email
            </AscButton>
          </footer>
        ) : null}
      </div>
    </AscAuthFlowLayout>
  );
}
